const videos = [
    {"value":"https://www.youtube.com/watch?v=Lju6h-C37hE"},
    {"value":"https://www.youtube.com/watch?v=wruCWicGBA4" }, 
    {"value":"https://www.youtube.com/watch?v=2OEL4P1Rz04"},
    {"value":"https://www.youtube.com/watch?v=-pBLZzZdQ0s"},
    {"value":"https://www.youtube.com/watch?v=hlWiI4xVXKY"},
    {"value":"https://www.youtube.com/watch?v=9uIk_91GQYI"},
    {"value":"https://www.youtube.com/watch?v=S8In3GrtiUM"},
    {"value":"https://www.youtube.com/watch?v=YRS0EScCWY0"},
    {"value":"https://www.youtube.com/watch?v=R9Yg1IPFW-E&t=92s"},
    {"value":"https://www.youtube.com/watch?v=LdpJXIV6y60"},
    {"value":"https://www.youtube.com/watch?v=Hzi3PDz1AWU"},
    {"value":"https://www.youtube.com/watch?v=inpok4MKVLM"},
    {"value":"https://www.youtube.com/watch?v=XnT_cOq_Ba8"},
    {"value":"https://www.youtube.com/watch?v=77ZozI0rw7w"},
    {"value":"https://www.youtube.com/watch?v=QZbuj3RJcjI"},
    {"value":"https://www.youtube.com/watch?v=Gqfk5sr9fpw"}
    

]

export default videos;